import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Timeline.css";

const timelineData = [
  {
    category: "Business Setup & Compliance",
    services: [
      {
        title: "Company Formation",
        description: "End-to-end registration of business entities: INDIA (Private Limited, LLP, OPC), US (LLC, S-Corp, or C-Corp), including compliance, documentation, EIN application, and registered agent services.",
      },
      {
        title: "Legal & Compliance Support",
        description: "Trademark registration, business contracts, MoA drafting, and legal consulting for businesses in India and the US, with MCA compliance in India and USPTO filing plus state-level compliance in the US.",
      },
      {
        title: "Tax & Financial Services",
        description: "Comprehensive tax and financial support including GST registration, federal/state tax filings, income tax filing, EIN registration, audits, bookkeeping, accounting, and CPA services.",
      },
      {
        title: "Banking & Payment Solutions",
        description: "Assistance with business bank accounts, merchant services, payment gateways, and financial infrastructure setup for smooth operations in both Indian and US markets.",
      }
    ],
  },
  {
    category: "Web & Digital Solutions",
    services: [
      {
        title: "Branding & Logo Design",
        description: "Complete visual identities including logos, color palettes, brand guidelines, and investor-focused branding kits tailored to your market.",
      },
      {
        title: "Website Development",
        description: "Custom responsive websites with localized content, supporting multiple languages and compliant infrastructure for businesses in India and the US.",
      },
      {
        title: "App & E-commerce Development",
        description: "Mobile apps and e-commerce platforms with integrated payment gateways (Stripe, PayPal, Razorpay) and inventory management systems.",
      },
      {
        title: "Digital Content Creation",
        description: "SEO-optimized content, blog writing, ad copy, sales emails, and product-focused writing for global audiences with localization support.",
      }
    ],
  },
  {
    category: "Marketing & Strategy",
    services: [
      {
        title: "Business Strategy Consulting",
        description: "Growth roadmaps, market entry strategies, funding plans, and go-to-market strategies for scaling your business effectively.",
      },
      {
        title: "Digital Marketing",
        description: "Meta and Google ads, influencer marketing, reels, paid social campaigns, and data-driven strategies tailored for your target markets.",
      },
      {
        title: "Investor & Pitch Support",
        description: "Investor pitch decks, financial projections, and fundraising strategy development to help secure capital for growth.",
      },
      {
        title: "Localization Services",
        description: "Cultural adaptation of marketing materials, website localization, and region-specific campaign strategies for India and US markets.",
      }
    ],
  },
  {
    category: "Business Essentials",
    services: [
      {
        title: "Corporate Identity Package",
        description: "Welcome kits, ID cards, office signage, and printed marketing material to establish your professional brand presence.",
      },
      {
        title: "HR & Recruitment Support",
        description: "Complete HR solutions including job postings, offer letters, policies, onboarding, and payroll coordination.",
      },
      {
        title: "Virtual Office Solutions",
        description: "Mail handling, virtual addresses, phone answering services, and meeting space rentals for flexible business operations.",
      },
      {
        title: "Business Documentation",
        description: "Preparation of all necessary business documents, contracts, and compliance paperwork for smooth operations.",
      }
    ],
  },
  {
    category: "Ongoing Support & Maintenance",
    services: [
      {
        title: "Website & IT Maintenance",
        description: "Regular security updates, backups, bug fixes, and content management to keep your digital presence flawless.",
      },
      {
        title: "Compliance Renewals",
        description: "Annual filings, license renewals, and ongoing compliance management to keep your business in good standing.",
      },
      {
        title: "Continuous Marketing Support",
        description: "Ongoing SEO, content updates, and campaign management to maintain your market presence.",
      },
      {
        title: "Business Growth Advisory",
        description: "Regular strategy sessions and performance reviews to ensure continuous business growth and adaptation.",
      }
    ],
  },
];

const Timeline = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true });
  }, []);

  return (
    <div className="timeline-container">
      <h2 className="timeline-heading">Begin Boldly. We’ll Back You All the Way.</h2>
      {timelineData.map((category, categoryIndex) => (
        <div key={categoryIndex} className="timeline-category">
          <h3 className="category-heading">{category.category}</h3>
          <ul className="timeline">
            <div className="timeline-start-circle"></div>

            {category.services.map((item, index) => (
              <li
                key={index}
                className={`timeline-item ${index % 2 === 0 ? "right" : "left"}`}
                data-aos={index % 2 === 0 ? "fade-left" : "fade-right"}
              >
                <div className="circle"></div>
                <div className="content">
                  <h3 className="title">{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </li>
            ))}

            <div className="timeline-end-circle"></div>
          </ul>
        </div>
      ))}
    </div>
  );
};

export default Timeline;